import React from 'react';

import PropTypes from 'prop-types';
import classnames from 'clsx';

import { useWizard } from 'ui-components/components/wizard/context';

import style from '../style.module.less';

export const WizardStep = ({ stepId, children, className = '' }) => {
  const { activeStep } = useWizard();

  const isActiveStep = activeStep.stepId === stepId;

  if (!isActiveStep) {
    return null;
  }

  return <div className={classnames(style['wizard-body'], className)}>{children}</div>;
};

WizardStep.propTypes = {
  stepId: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  className: PropTypes.string,
};

WizardStep.displayName = 'WizardStep';
